/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');

var parsleyUtil = require('common/util/parsleyUtil');
var makeUploadCollection = require('common/util/makeUploadCollection');

var CommentsDocumentView = require('common/views/CommentsDocumentView');

var tmplDepNewBankCharterArticlesOfIncorpSectionView = require('./DepNewBankCharterArticlesOfIncorpSectionView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplDepNewBankCharterArticlesOfIncorpSectionView,

  className: 'dep-new-bank-charter-articles-of-incorp-section-view',

  behaviors: {
    ReadOnlyFormBehavior: {}
  },

  ui: {
    documentForm: '.document-form',
    articlesOfIncorporationContainer: '.articles-of-incorporation-container',
    bylawsContainer: '.bylaws-container'
  },

  regions: {
    articlesOfIncorporationContainer: '@ui.articlesOfIncorporationContainer',
    bylawsContainer: '@ui.bylawsContainer'
  },

  templateHelpers: function() {
    return {
      isReadOnly: this.options.isReadOnly
    };
  },

  onBeforeShow: function() {
    var filingContent = this.model.get('filingContent') || {};
    var articlesOfIncorporation = filingContent.articlesOfIncorporation || {};
    var bylaws = filingContent.bylaws || {};

    Syphon.deserialize(this, this.model.get('filingContent'));

    this.articlesOfIncorporation = new CommentsDocumentView({
      isReadOnly: this.options.isReadOnly,
      allowMultipleFiles: false,
      isRequired: true,
      fileUploadLabel: 'Articles of Incorporation',
      commentsLabel: 'Articles of Incorporation Comments',
      commentsName: 'articlesOfIncorporationComments',
      collection: makeUploadCollection(articlesOfIncorporation.file),
      model: new Backbone.Model({
        articlesOfIncorporationComments: articlesOfIncorporation.articlesOfIncorporationComments
      }),
      documentTypeId: 20001
    });
    this.showChildView('articlesOfIncorporationContainer', this.articlesOfIncorporation);

    this.bylaws = new CommentsDocumentView({
      isReadOnly: this.options.isReadOnly,
      allowMultipleFiles: false,
      isRequired: true,
      fileUploadLabel: 'Bylaws',
      commentsLabel: 'Bylaws Comments',
      commentsName: 'bylawsComments',
      collection: makeUploadCollection(bylaws.file),
      model: new Backbone.Model({
        bylawsComments: bylaws.bylawsComments
      }),
      documentTypeId: 20001
    });
    this.showChildView('bylawsContainer', this.bylaws);
  },

  validate: function(config) {
    this.ui.documentForm.parsley().reset();
    this.articlesOfIncorporation.removeValidationErrors();
    this.bylaws.removeValidationErrors();

    if (config.type === 'save') {
      // Turn off required field validation for this form
      parsleyUtil.disableRequiredValidation(this.ui.documentForm);
    } else {
      var validationPromises = [
        this.ui.documentForm.parsley().whenValidate(),
        this.articlesOfIncorporation.validate(),
        this.bylaws.validate()
      ];

      // Turn on required field validation for this form
      parsleyUtil.enableRequiredValidation(this.ui.documentForm);
    }
    return $.when.apply($, validationPromises);
  },

  getFormData: function() {
    var formData = Syphon.serialize(this);
    formData.articlesOfIncorporationDocId = this.articlesOfIncorporation.getFirstFileId();
    formData.bylawsDocId = this.bylaws.getFirstFileId();
    return formData;
  }
});
